import { gql } from '@/__generated__';

export const CREATE_DEVICE = gql(`#graphql
  mutation CreateDevice($input: CreateDeviceInput!) {
    createDevice(input: $input) {
      id
      profile {
        id
        name
        serie
        sensor
        source
        sourceInfo
        type2
      }
    }
  }
`);
